import { defineStore } from 'pinia';

export default defineStore('mainImageStore', () => {
  const isMainImageInteracted = ref(false);

  return { isMainImageInteracted };
});
